// Type for productInfo as constructed in loadAndUploadTemplatesFromKnxProductDataFile

// Interface for productInfo as used in buildExtendedProductInfo

// no itx for this file
import JSZip from "jszip";
import DeviceTemplate from "./DeviceTemplate";
import KnxProductData from "../KnxProductdata";
import { showToast } from "../components/Toasts";
import { setUploadPercentage } from "./KnxProdUpload";
import { AllChildsWithTag, firstChildWithTag, Tag } from "../components/XmlUtils";
import KnxLanguageMappingXml from "../KnxProductDataTools/LanguageMappingXml";
import Logger from "../Logger";
import ProductStorageHandler from "../persistence/ProductStorageHandle";
import { decodeFromCP437 } from "../utils/UmlautEncodeDecode";
import XMLParserSingleton from "../XMLParserSingleton";
import { cleanEncode } from "../utils/CommonUtils";
import { EtsImportProductIdPrefix } from "./Constants";
import KnxProductInfo, { buildExtendedProductInfo, getEncodedOriginalMetadata } from "./KnxProductInfo";

import { getDecodedMetadata } from "./decodeKnxProductInfo";
export { getDecodedMetadata } from "./decodeKnxProductInfo";

const logger = new Logger();
const KNXPROD_UPLOAD_YIELD_INTERVAL = 10;

export interface SimpleProductInfo {
  modeldataId: string;
  name: string;
  productInfo: KnxProductInfo;
  xmlString: string;
}

function yieldDuringKnxprodUpload(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof MessageChannel !== "undefined") {
      const channel = new MessageChannel();
      channel.port1.onmessage = () => {
        channel.port1.close();
        channel.port2.close();
        resolve();
      };
      channel.port2.postMessage(undefined);
      return;
    }

    Promise.resolve().then(resolve);
  });
}

function getMasterFileName(zip: JSZip) {
  for (let i in zip.files) {
    if (i.indexOf("knx_master.xml") >= 0) {
      return i;
    }
  }
  return undefined;
}

function getHardwareFileName(zip: JSZip): string | undefined {
  let hardwareFiles: any = [];
  for (let i in zip.files) {
    if (i.indexOf("Hardware.xml") >= 0) {
      return i;
    }
  }
  return undefined;
}

function getCatalogFileName(zip: JSZip) {
  let catalogFiles: any = [];
  for (let i in zip.files) {
    if (i.indexOf("Catalog.xml") >= 0) {
      catalogFiles.push(i);
    }
  }
  return catalogFiles;
}

function getBaggageFileName(zip: JSZip) {
  let baggageFiles: any = [];
  for (let i in zip.files) {
    if (i.indexOf("Baggages.xml") >= 0) {
      baggageFiles.push(i);
    }
  }
  return baggageFiles;
}

async function getXmlFromZip(zip: JSZip, xmlName: string) {
  const text = await zip.files[xmlName].async("string");

  let xml: any = {};
  try {
    const parser = XMLParserSingleton.Instance;

    xml = parser.parse(text);
  } catch (ex) {
    console.log(" xml2js = require funktioniert nicht");
  }
  return xml;
}

export async function loadMasterInfos(mainZipfile: JSZip): Promise<{
  manufacturerInfos: any[];
  mediumTypesInfos: any[];
  maskVersionsInfo: any[];
}> {
  const name = getMasterFileName(mainZipfile);
  if (name) {
    var xml = await getXmlFromZip(mainZipfile, name);

    let MasterData = xml.KNX.MasterData;
    if (MasterData[0]) MasterData = MasterData[0];

    const Manufacturers = firstChildWithTag(MasterData, "Manufacturers");

    const manufacturerInfos = new Array<any>(...Manufacturers.items);

    const MediumTypes = firstChildWithTag(MasterData, "MediumTypes");

    const mediumTypesInfos = new Array<any>(...MediumTypes.items);

    const MaskVersions = firstChildWithTag(MasterData, "MaskVersions");

    const maskVersionsInfo = new Array<any>(...MaskVersions.items);

    const productInfos = {
      manufacturerInfos: manufacturerInfos,
      mediumTypesInfos: mediumTypesInfos,
      maskVersionsInfo: maskVersionsInfo,
    };

    logger.log("productInfos", productInfos);
    return productInfos;
  } else {
    return {
      manufacturerInfos: [],
      mediumTypesInfos: [],
      maskVersionsInfo: [],
    };
  }
}

export async function loadHardwareInfos(zip: JSZip): Promise<Array<KnxProductInfo> | undefined> {
  const name = getHardwareFileName(zip);
  let productInfos = new Array<any>();

  if (name) {
    var xml = await getXmlFromZip(zip, name);
    const productInfos2 = loadHardwareInfos2(xml);
    productInfos = productInfos.concat(productInfos2);

    return productInfos;
  }

  return undefined;
}

export function loadHardwareInfos2(hardwareFileContent: any): Array<KnxProductInfo> {
  let productInfos = new Array<KnxProductInfo>();

  const ManufacturerData = firstChildWithTag(hardwareFileContent.KNX, "ManufacturerData");
  for (let i in ManufacturerData.items) {
    const Manufacturer = ManufacturerData.items[i];
    const ManufacturerId = Manufacturer.a.RefId;

    const Hardware = firstChildWithTag(Manufacturer, "Hardware");

    for (let h in Hardware.items) {
      const hardwareItem = Hardware.items[h];

      const Hardware2Programs = firstChildWithTag(hardwareItem, "Hardware2Programs");
      logger.log("Hardware2Program", Hardware2Programs);

      const ApplicationPrograms = new Array<any>();

      let ApplicationProgramRefId = "";
      if (Hardware2Programs) {
        for (let i in Hardware2Programs.items) {
          const Hardware2Program = Hardware2Programs.items[i];

          const id = Hardware2Program.a.Id;
          const mediumType = Hardware2Program.a.MediumTypes;
          const ApplicationProgramRefs = AllChildsWithTag(Hardware2Program, "ApplicationProgramRef");

          if (ApplicationProgramRefs) {
            for (const ApplicationProgramRef of ApplicationProgramRefs) {
              ApplicationProgramRefId = ApplicationProgramRef.a.RefId;
              logger.log(`ApplicationProgramRef  id=${id} ApplicationProgramRef=${ApplicationProgramRefId}`);
              ApplicationPrograms.push({
                Id: ApplicationProgramRefId,
                Hardware2ProgramRefId: id,
                MediumType: mediumType,
              });
            }
          } else {
            ApplicationPrograms.push({
              Id: ApplicationProgramRefId,
              Hardware2ProgramRefId: id,
              MediumType: mediumType,
            });
          }
        }
      }

      const Products = firstChildWithTag(hardwareItem, "Products");
      for (let i2 in Products.items) {
        const product = Products.items[i2];

        productInfos.push({
          Hardware: {
            ...hardwareItem.a,
            ManufacturerId: ManufacturerId,
          },
          ApplicationPrograms: ApplicationPrograms,
          ...product.a,
        });
      }
    }
  }

  return productInfos;
}

export async function loadCatalogInfos(zip: JSZip): Promise<any> {
  const names = getCatalogFileName(zip);
  let catalogInfoList = new Array<any>();
  for (const name of names) {
    var xml = await getXmlFromZip(zip, name);

    const KNX = xml.KNX;

    const ManufacturerData = firstChildWithTag(KNX, "ManufacturerData");
    const Manufacturer = firstChildWithTag(ManufacturerData, "Manufacturer");

    const Catalog = firstChildWithTag(Manufacturer, "Catalog");
    const Languages = firstChildWithTag(Manufacturer, "Languages");

    const catalogInfos = {
      catalog: loadCatalogInfosX("", Catalog),
      languages: Languages,
    };
    catalogInfoList.push(catalogInfos);
  }
  return catalogInfoList;
}

export async function loadBaggageInfos(zip: JSZip): Promise<any> {
  const names = getBaggageFileName(zip);
  let baggageInfos = new Array<any>();
  for (const name of names) {
    var xml = await getXmlFromZip(zip, name);

    const KNX = xml.KNX;
    const ManufacturerData = firstChildWithTag(KNX, "ManufacturerData");
    const Manufacturer = firstChildWithTag(ManufacturerData, "Manufacturer");
    const Baggages = firstChildWithTag(Manufacturer, "Baggages");

    for (let i in Baggages.items) {
      const item = Baggages.items[i];
      const imageFilename = item.a.Name;
      for (let file in zip.files) {
        const fileInfo = item?.FileInfo;
        let timeInfo = "";
        if (Array.isArray(fileInfo)) {
          timeInfo = fileInfo[0]?.a?.TimeInfo || "";
        } else {
          timeInfo = fileInfo?.a?.TimeInfo || "";
        }
        const manId = Manufacturer.a.RefId || "";
        const fullPath = "Baggages/" + (item.a?.TargetPath ? item.a?.TargetPath + "/" : "") + imageFilename;
        if (file.indexOf(fullPath) >= 0 || file.indexOf(`${manId}/${fullPath}`) >= 0) {
          const imageFile = zip.files[file];
          if (!imageFile) {
            logger.error("loadBaggageInfos: imageFile is undefined");
            continue;
          }
          const imageData = await imageFile.async("blob");
          baggageInfos.push({
            ...item.a,
            TimeInfo: timeInfo,
            BaggagePath: fullPath,
            ZipPath: file,
            Image: imageData,
          });
          break;
        }
      }
    }
  }
  logger.log("baggageInfos", baggageInfos);
  return baggageInfos;
}

function loadCatalogInfosX(type: string, parent: any) {
  var res = new Array<any>();
  for (let j in parent.items) {
    const item = parent.items[j];
    if (Tag(item) == "CatalogItem") {
      item.a["Type"] = type;
      res.push(item);
    } else if (Tag(item) == "CatalogSection") {
      const fullType = type + "/" + (item.a?.Name || "");
      res = res.concat(loadCatalogInfosX(fullType, item));
    }
  }

  return res;
}

export async function loadOneProductDatamodelString(
  mainZipFile: JSZip,
  ManufacturerId: string,
  ApplicationProgramId: string,
): Promise<string> {
  const filename = `${ManufacturerId}/${ApplicationProgramId}.xml`;
  const file = mainZipFile.files[filename];
  const text = await file.async("string");
  return text;
}

export async function uploadBadgesToServer(baggageInfos: any[]) {
  // Upload All Images inside Baggage Folder to Server
  for (let i in baggageInfos) {
    if (Number(i) > 0 && Number(i) % KNXPROD_UPLOAD_YIELD_INTERVAL === 0) {
      await yieldDuringKnxprodUpload();
    }

    let data = baggageInfos[i];
    const image = data.Image;
    const id = cleanEncode(data.Id?.trim());
    delete data.Image;
    delete data.Id;
    data.Name = cleanEncode(data.Name?.trim());
    const metadata = data;

    const existingImageData = await ProductStorageHandler.downloadImageData(id);
    if (!existingImageData) {
      await ProductStorageHandler.uploadImageData(id, image, metadata);
    }
  }
}

function getBaggageImageIds(data: any): string[] {
  const ids = new Set<string>();
  const addId = (id?: string) => {
    const value = id?.trim();
    if (value) ids.add(value);
  };

  addId(data.Id);
  addId(data.Name);
  addId(data.BaggagePath);
  addId(data.ZipPath);

  return Array.from(ids);
}

export async function cacheBadgesLocally(baggageInfos: any[]) {
  for (let i in baggageInfos) {
    if (Number(i) > 0 && Number(i) % KNXPROD_UPLOAD_YIELD_INTERVAL === 0) {
      await yieldDuringKnxprodUpload();
    }

    const data = baggageInfos[i];
    const image = data.Image;
    if (!image) continue;

    const metadata = { ...data };
    delete metadata.Image;

    const imageIds = getBaggageImageIds(data);
    await Promise.all(imageIds.map((imageId) => ProductStorageHandler.cacheImageData(imageId, image, metadata)));
  }
}

export async function loadAndUploadTemplatesFromKnxProductDataFile(
  file: File,
  isUpload: boolean, // Set only when product data upload to server is required
  azureCatalogMetaData: any,
  userImportCalatogID?: string,
  note?: string,
  productType?: string,
  onProgress?: (percentage: number) => void,
): Promise<Array<SimpleProductInfo>> {
  var res = new Array<SimpleProductInfo>();
  const reportProgress = (percentage: number) => {
    const boundedPercentage = Number.isFinite(percentage) ? Math.max(0, Math.min(100, percentage)) : 0;
    if (onProgress) {
      onProgress(boundedPercentage);
    } else {
      setUploadPercentage(boundedPercentage);
    }
  };

  reportProgress(1);

  const mainZipFile = await JSZip.loadAsync(file, {
    decodeFileName: (bytes) => decodeFromCP437(bytes),
    // CP437 - Multibyte encode that support Umlaut (ä,ö etc) characters
  });

  reportProgress(5);

  const catalogInfos = await loadCatalogInfos(mainZipFile);

  const masterInfos = await loadMasterInfos(mainZipFile);
  const baggageInfos = await loadBaggageInfos(mainZipFile);

  const productInfos = await loadHardwareInfos(mainZipFile);

  reportProgress(10);

  if (isUpload) {
    await uploadBadgesToServer(baggageInfos);
  } else {
    await cacheBadgesLocally(baggageInfos);
  }
  reportProgress(15);

  const hardwareFilename = getHardwareFileName(mainZipFile);
  if (!hardwareFilename) {
    throw new Error("Hardware.xml not found in knxprod file.");
  }

  var HardwareFileContent = await getXmlFromZip(mainZipFile, hardwareFilename);
  const totalCatalogItems = catalogInfos.reduce((sum: number, catalogInfo: any) => {
    return sum + (catalogInfo?.catalog?.length || 0);
  }, 0);
  let processedCatalogItems = 0;
  const catalogProgressStart = 15;
  const catalogProgressRange = 85;

  for (let k in catalogInfos) {
    // For All products/application programs
    const catalog = catalogInfos[k]?.catalog;
    const cataloglanguages = catalogInfos[k]?.languages;
    const catalogLanguageMapping = new KnxLanguageMappingXml();
    if (cataloglanguages) {
      catalogLanguageMapping.load(cataloglanguages);
    }

    // let parsedIdList = new Set();
    for (let i in catalog) {
      if (processedCatalogItems > 0 && processedCatalogItems % KNXPROD_UPLOAD_YIELD_INTERVAL === 0) {
        await yieldDuringKnxprodUpload();
      }

      const CatalogItem = catalog[i];
      const itemStartPercentage =
        totalCatalogItems > 0
          ? catalogProgressStart + (processedCatalogItems / totalCatalogItems) * catalogProgressRange
          : 100;
      const itemEndPercentage =
        totalCatalogItems > 0
          ? catalogProgressStart + ((processedCatalogItems + 1) / totalCatalogItems) * catalogProgressRange
          : 100;
      const itemProgressRange = itemEndPercentage - itemStartPercentage;
      reportProgress(itemStartPercentage);

      const productMeta = await buildExtendedProductInfo(
        mainZipFile,
        masterInfos,
        catalogLanguageMapping,
        CatalogItem,
        HardwareFileContent,
      );

      if (isUpload) {
        // ### 05.08.2025: Important Addition
        // New verification added to make sure metadata is not entirely destroyed on server when uploading an existing product application via .knxprod
        // Rather the existing metadata is merged with new product attribuites
        // Helpful in updating meta with missing attributes; preserves metadata structure
        // In this way, we don't need to modify any api's on backend side.

        // Prefer the already loaded catalog cache to avoid downloading the full product
        // overview before every KNXPROD upload. If the product is not cached, fetch only
        // that product's metadata so existing manual catalog fields are still preserved.
        let existingMeta = Array.isArray(azureCatalogMetaData)
          ? azureCatalogMetaData.find((item: any) => item.CatalogId == productMeta.CatalogId)
          : undefined;
        if (!existingMeta && productMeta.CatalogId) {
          existingMeta = await ProductStorageHandler.getProductMetaData(productMeta.CatalogId);
        }
        if (existingMeta) existingMeta = await getEncodedOriginalMetadata(existingMeta);

        const mergedMeta: KnxProductInfo = mergeMetadatas(existingMeta, productMeta);

        // upload one application programm Xml to the server
        // Replaced ApplicationProgramId with productInfo.Id as blobId
        // as ApplicationProgramId is not necessarily unique but catalogId is.
        // catalogId also has OrderId in it's syntax
        // E.g. M-0083_H-174-1_P-BE.2DGBZx.2E01 has OrderId: BE-GBZx.01

        if (userImportCalatogID) {
          mergedMeta.UserImport = "true";
        }

        if (note) {
          mergedMeta.Note = note;
        }

        mergedMeta.ProductType = productType || "";

        if (!userImportCalatogID || userImportCalatogID.split(EtsImportProductIdPrefix)[1] == mergedMeta.CatalogId) {
          let xId = userImportCalatogID || mergedMeta.CatalogId; // + "-D1";
          // mergedMeta.CatalogId = xId; // Important: Avoiding override of existing metadata, as we are merging existing with new metadata. This way we can preserve existing metadata structure and just add missing attributes from new metadata.
          // mergedMeta.Id = xId;
          // mergedMeta.Variants = "";

          console.log("uploadProductData disables for knxprod import: " + xId);
          console.log("mergedMeta", mergedMeta);

          const modeldataXmlString = await createApplicationProgramsString(
            mainZipFile,
            productMeta.ManufacturerId,
            productMeta.ApplicationPrograms || [],
          );
          reportProgress(itemStartPercentage + itemProgressRange * 0.35);

          //
          if (mergedMeta.ApplicationPrograms) {
            delete mergedMeta?.ApplicationPrograms;
          }

          //
          // Upload the data to our server
          //

          await ProductStorageHandler.uploadProductData(xId, modeldataXmlString, mergedMeta, (progressEvent: any) => {
            const uploadProgress =
              typeof progressEvent?.progress == "number"
                ? progressEvent.progress
                : progressEvent?.total
                  ? progressEvent.loaded / progressEvent.total
                  : 0;
            reportProgress(itemStartPercentage + itemProgressRange * (0.35 + uploadProgress * 0.6));
          }); // Add "-Dx" where x= 2,3,... for manual duplicate uploads. This is important to avoid override of existing metadata when the same product is uploaded multiple times via knxprod file. With this approach we can preserve existing metadata structure and just add missing attributes from new metadata in case of multiple uploads of the same product.

          const uploadedMetadata = getDecodedMetadata({ ...mergedMeta });
          res.push({
            modeldataId: xId,
            name: buildTemplateName(uploadedMetadata),
            productInfo: uploadedMetadata,
            xmlString: modeldataXmlString,
          });

          ////////////////////////////////////////////////////////////////////////////////////////////////////////
        }
      } else {
        const modeldataXmlString = await createApplicationProgramsString(
          mainZipFile,
          productMeta.ManufacturerId,
          productMeta.ApplicationPrograms || [],
        );
        const metadata = getDecodedMetadata(productMeta);
        metadata.UserImport = "true";
        delete metadata.ApplicationPrograms;

        res.push({
          modeldataId: metadata.CatalogId,
          name: buildTemplateName(metadata),
          productInfo: metadata,
          xmlString: modeldataXmlString,
        });
      }
      processedCatalogItems++;
      reportProgress(itemEndPercentage);
    }
  }
  reportProgress(100);
  return res;
}

export async function loadTemplatesFromKnxProductDataFiles(files: any): Promise<Array<DeviceTemplate>> {
  var knxProductDatas = new Array<SimpleProductInfo>();
  const uploadFiles = Array.from(files || []) as any[];
  const totalFiles = uploadFiles.length;
  // allMetadatas is only needed for server-upload (isUpload=true); skip the network call here
  const allMetadatas: any[] = [];

  if (totalFiles > 0) {
    setUploadPercentage(1);
  }

  for (let i = 0; i < totalFiles; i++) {
    const file: any = uploadFiles[i];
    const fileStartPercentage = 1 + (i / totalFiles) * 99;
    const fileEndPercentage = 1 + ((i + 1) / totalFiles) * 99;
    const updateFileProgress = (filePercentage: number) => {
      const bounded = Number.isFinite(filePercentage) ? Math.max(0, Math.min(100, filePercentage)) : 0;
      setUploadPercentage(fileStartPercentage + ((fileEndPercentage - fileStartPercentage) * bounded) / 100);
    };

    if (file.name.endsWith(".knxprod")) {
      try {
        knxProductDatas = knxProductDatas.concat(
          await loadAndUploadTemplatesFromKnxProductDataFile(
            file,
            false,
            allMetadatas,
            undefined,
            undefined,
            undefined,
            updateFileProgress,
          ),
        );
        setUploadPercentage(fileEndPercentage);
      } catch (ex: any) {
        logger.error(ex);
        showToast({
          text: state.translate("UploadImageScreen.uploadError", "Loading error: $e").replace("$e", ex?.DATA || ""),
        });
      }
    } else {
      showToast({
        text: state.translate("knxprodLoader.invalidFileType", "Invalid file type (should be.knxprod)"),
        isError: true,
      });
    }
  }

  var res = new Array<DeviceTemplate>();

  for (let i in knxProductDatas) {
    const knxProductdata = knxProductDatas[i];

    const template = new DeviceTemplate({
      name: knxProductdata.name,
    });
    template.knxProductData = new KnxProductData(
      {
        modelDataId: knxProductdata.modeldataId,
        productInfo: knxProductdata.productInfo,
        xmlString: knxProductdata.xmlString,
      },
      template,
    );

    // template.knxInstanceData = new KnxInstanceData();
    res.push(template);

    logger.log("loadTemplatesFromKnxProductDataFiles", res);
  }

  if (totalFiles > 0) {
    setUploadPercentage(100);
  }

  return res;
}

function buildTemplateName(productInfo: KnxProductInfo): string {
  const parts = [
    productInfo.ManufacturerName,
    productInfo.OrderNumber,
    productInfo.ProductName || productInfo.DefaultProductName,
    productInfo.Application ? `(${productInfo.Application})` : "",
  ];

  return (
    parts
      .filter((part) => !!part)
      .join(" ")
      .trim() ||
    productInfo.CatalogId ||
    productInfo.Id ||
    ""
  );
}

export function mergeMetadatas(existing: KnxProductInfo | undefined, newproduct: KnxProductInfo): KnxProductInfo {
  if (!existing) return newproduct;

  const allKeys = new Set([...Object.keys(existing || {}), ...Object.keys(newproduct || {})]);

  const mergedMeta: any = {};
  for (const key of allKeys) {
    const existingValue = existing[key];
    const newValue = newproduct[key];
    mergedMeta[key] =
      existingValue !== undefined && existingValue !== "" ? existingValue : newValue !== undefined ? newValue : "";
  }
  return mergedMeta;
}

export function getTranslatedMetadata(metadata: any, language: string): any {
  if (metadata?.ProductNames && metadata?.ProductNames[language]) {
    metadata.ProductName = metadata.ProductNames[language];
  } else {
    metadata.ProductName = metadata.DefaultProductName;
  }
  if (metadata?.ProductDescriptions && metadata?.ProductDescriptions[language]) {
    metadata.ProductDescription = metadata.ProductDescriptions[language];
  } else {
    metadata.ProductDescription = "";
  }
  if (metadata?.Applications && metadata?.Applications[language]) {
    metadata.Application = metadata.Applications[language];
  } else {
    metadata.Application = metadata.DefaultApplication;
  }
  return metadata;
}

async function createApplicationProgramsString(
  mainZipFile: JSZip,
  ManufacturerId: string,
  ApplicationPrograms: string[],
): Promise<string> {
  let modeldataXmlString = "";

  for (let ApplicationProgramId of ApplicationPrograms) {
    if (ApplicationProgramId) {
      try {
        if (modeldataXmlString !== "") {
          modeldataXmlString += "<AP2StartsHere>" + ApplicationProgramId + "\n";
        }

        const ap2modeldataXmlString = await loadOneProductDatamodelString(
          mainZipFile,
          ManufacturerId,
          ApplicationProgramId,
        );
        modeldataXmlString += ap2modeldataXmlString;
      } catch (ex) {
        logger.error(ex);
      }
    }
  }

  return modeldataXmlString;
}
